
import { Navigate, Outlet } from "react-router-dom";
import { useAppSelector } from "../../redux/hook";

export const AdminProtectedRoute = () => {
  const { isAdmin, isUserAdmin } = useAppSelector(
    (state) => state.userRoles.userRoles
  );

  const isAdminUser = isAdmin || isUserAdmin;

  return isAdminUser ? (
    <Outlet />
  ) : (
   // change in 2026
   //<Navigate to="/PV/UNAUTHORIZED_PATH" replace /> 
  <Navigate to="/auditMenu" replace />
  );
};
